import { defineMessages } from 'react-intl';

const _default_1: {
	editSite: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	logout: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	profile: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	editSite: {
		id: 'hub-app-shell.avatar-menu.edit-site',
		defaultMessage: 'Edit site',
		description:
			'The text is shown as a drop-down menu item in the avatar menu, allowing the site administrator to navigate to the site editing interface.',
	},
	profile: {
		id: 'hub-app-shell.avatar-menu.profile',
		defaultMessage: 'Profile',
		description:
			'The text is shown as a drop-down menu item in the avatar menu, allowing the current user to navigate to their profile page.',
	},
	logout: {
		id: 'hub-app-shell.avatar-menu.logout',
		defaultMessage: 'Logout',
		description:
			'The text is shown as a drop-down menu item in the avatar menu that, when clicked, signs the current user out of the application.',
	},
});
export default _default_1;
